import { ClipboardButton as SharedClipboardButton } from 'corso-admin-ui';
import { ComponentProps } from 'react';
import { useToast } from '~/hooks/useToast';

/** @deprecated We should ideally remove this wrapper and just use the `ClipboardButton` from `corso-admin-ui` directly, and resolve differences around toasts handling. */
export default function ClipboardButton(
  props: Omit<ComponentProps<typeof SharedClipboardButton>, 'onCopy'>,
) {
  const toast = useToast();

  return (
    <SharedClipboardButton
      // oxlint-disable-next-line react/jsx-props-no-spreading
      {...props}
      onCopied={() => {
        toast.show('Copied to clipboard');
      }}
    />
  );
}
